/**
 * Suggested amounts per currency for the payin amount field, as raw decimal strings (the preview endpoint
 * rejects separators). One place instead of a constant per form: three had already drifted apart, two of them
 * typed as numbers and one as strings.
 *
 * Chosen to span the realistic range of a single collection in each market, not to be round in USD.
 */
export const PAYIN_QUICK_AMOUNTS: Readonly<Record<string, readonly string[]>> = {
  COP: ["100000", "500000", "1000000", "5000000"],
  BRL: ["100", "500", "1000", "5000"],
  MXN: ["500", "1000", "5000", "10000"],
  ARS: ["50000", "100000", "500000", "1000000"],
};

/** Quick amounts for a currency, or none — an unlisted currency simply renders no badges. */
export const quickAmountsFor = (currency: string): readonly string[] =>
  PAYIN_QUICK_AMOUNTS[currency.toUpperCase()] ?? [];
